import {useCallback} from "react";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";

export const useLocaleChanger = () => {
	const {t, i18n} = useTranslation('common');
	const router = useRouter();

	const setLocale = useCallback(async (key: string) => {
		return i18n.changeLanguage(key).then(async () => {
			await fetch(`/frontend-api/locale?locale=${key}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
			}).then(async (res) => {
				console.debug(await res.json());
			});

			const {pathname, asPath, query} = router;
			await router.push(
				{
					pathname,
					query
				},
				router.asPath,
				{
					locale: key,
					scroll: false,
					shallow: (process.env.NEXT_PUBLIC_APP_DEFAULT_LOCALE || 'pl') == key
				}
			);

			if ((process.env.NEXT_PUBLIC_APP_DEFAULT_LOCALE || 'pl') == key) // default locale not refresh route its so bugged, using this crutch
			{
				setTimeout(() => {
					router.replace(router.asPath);
				}, 100);
			}
		})
	}, [router, i18n]);

	return {
		setLocale,
	};
}